
(function( $ ) {

    /* Vlastní funkce
    ========================================================*/
    function get_lang(){
        if ( $("body").hasClass( 'english' ) ) {
            return "en";
        } else {
            return "cs";
        }
    }

    //funkce vráí
    function get_browser() {

        var ua=navigator.userAgent,tem,M=ua.match(/(opera|yabrowser|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || []; 

        if(/trident/i.test(M[1])){
            tem=/\brv[ :]+(\d+)/g.exec(ua) || []; 
            return {name:'IE',version:(tem[1]||'')};
            }   

        if(M[1]==='Chrome'){
            tem=ua.match(/\bOPR|Edge\/(\d+)/)
            if(tem!=null)   {return {name:'Opera', version:tem[1]};}
            }   

        M=M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
        if((tem=ua.match(/version\/(\d+)/i))!=null) {M.splice(1,1,tem[1]);}

        return {
            name: M[0],
            version: M[1]
        };

    }

    //funkce
    function iOSversion() {

        if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
            if (!!window.indexedDB) { return 8; }
            if (!!window.SpeechSynthesisUtterance) { return 7; }
            if (!!window.webkitAudioContext) { return 6; }
            if (!!window.matchMedia) { return 5; }
            if (!!window.history && 'pushState' in window.history) { return 4; }
            return 3;
        }

        return '';

    }

    //add css script with js
    function append_no_flexbox(){
        document.querySelector('head').innerHTML += '<link rel="stylesheet" href="'+ globaldata.theme_url +'/assets/styles/specific-css/minified/noflexbox.css" type="text/css"/>';
    }

    /* slidein functionality
    ========================================================*/

    $.fn.visible = function(partial) {
        
        var $t            = $(this),
            $w            = $(window),
            viewTop       = $w.scrollTop(),
            viewBottom    = viewTop + $w.height(),
            _top          = $t.offset().top,
            _bottom       = _top + $t.height(),
            compareTop    = partial === true ? _bottom : _top,
            compareBottom = partial === true ? _top : _bottom;
        
        return ((compareBottom <= viewBottom) && (compareTop >= viewTop));

    }; 

    var win = $(window);
    var allMods = $(".slide-up");

    win.on( 'scroll load', function(event) {
        //slide up
        allMods.each(function(i, el) {
            var el = $(el);
            if (el.visible(true)) {
                el.addClass("come-in"); 
            } 
        });
        
    }); 

    /* Jednotlivé akce
    ========================================================*/

    //sidebar menu functionality
    jQuery(document).ready( function(){  
                
        //mobilní menu
        $( "#mobile-menu li" ).each(function( index, element ){

            var classes = $(this).attr('class');

            //add arrows to elements with children  
            if (  classes.indexOf("menu-item-has-children") >= 0 ) {

                $(this).prepend('<i class="arrow"> </i>');
            }  

        });

        //click functionality
        $("#mobile-menu .arrow").click(function(){
              
            if ( $("#mobile-menu > .menu-item-has-children").hasClass("showing-ul") ) {
                //exclude this element
                var myParent = $(this).closest("#mobile-menu > .menu-item-has-children");
                $("#mobile-menu > .menu-item-has-children").not(myParent).removeClass("showing-ul").children(".sub-menu").slideUp();
            }

            //show signling
            if ( $(this).parent().hasClass("showing-ul") )  {
                $(this).siblings(".sub-menu").slideUp();
                $(this).parent().removeClass("showing-ul");
            } else {
                $(this).siblings(".sub-menu").slideDown();
                $(this).parent().addClass("showing-ul");
            }       

        });

        // Remove empty P tags created by WP inside of Accordion and Orbit
        jQuery('.accordion p:empty, .orbit p:empty').remove();

        // Adds Flex Video to YouTube and Vimeo Embeds
        jQuery('.entry-content iframe[src*="youtube.com"], .entry-content iframe[src*="vimeo.com"]').each(function() {
            jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
        });

        if ($(".project .entry-content .wp-block-gallery").length > 0) {
            //add gallery items src
            $("img", $(".project .entry-content")).each(function () {
                var src = $(this).attr("data-lazyimg");
                var caption = $(this).next("figcaption").text();

                if (src !== undefined && src !== "") {
                    $(this)
                        .closest(".wp-block-image")
                        .attr("data-src", src);
                }
                if (caption !== undefined && caption !== "") {
                    $(this)
                        .closest(".wp-block-image")
                        .attr("data-sub-html", caption);
                }
            });

            //fire up gallery
            $(".project .entry-content").lightGallery({
                selector: ".wp-block-image",
            });

        }

        if ($("#timeline-grid .wp-block-gallery").length > 0) {
            //add gallery items src
            $("img", $(".wp-block-gallery")).each(function () {
                var src = $(this).attr("data-lazyimg");
                var caption = $(this).next("figcaption").text();

                if (src !== undefined && src !== "") {
                    $(this)
                        .closest(".wp-block-image")
                        .attr("data-src", src);
                }
                if (caption !== undefined && caption !== "") {
                    $(this)
                        .closest(".wp-block-image")
                        .attr("data-sub-html", caption);
                }
            });

            //fire up gallery
            $(".wp-block-gallery").lightGallery({
                selector: ".wp-block-image",
            });

        }

        if ($(".wds-pdf-gallery .wp-block-gallery").length > 0) {
            //add gallery items src
            $("img", $(".wp-block-gallery")).each(function () {
                var src = $(this).attr("data-lazyimg");
                var caption = $(this).next("figcaption").text();

                if (src !== undefined && src !== "") {
                    $(this)
                        .closest(".wp-block-image")
                        .attr("data-src", src);
                }
                if (caption !== undefined && caption !== "") {
                    $(this)
                        .closest(".wp-block-image")
                        .attr("data-sub-html", caption);
                }
            });

            //fire up gallery
            $(".wp-block-gallery").lightGallery({
                selector: ".wp-block-image",
            });

        }


        if ( $('.lightgallery').length > 0 ) { 			
			//fire up gallery
		    $('.lightgallery').lightGallery({
				selector : '.lightgallery a'
			});
		}
          

    }); 

    //show or hide the top menu
    $(window).on( "scroll load", function() {

        if ($(window).scrollTop() >= 25 ) {
            
            if ( !$('body').hasClass('scrolled')){

                $('body').addClass('scrolled');
                $('#main-menu-container').hide().fadeIn(); 

            }
                                                  
        //reverse it back    
        } else if ($(window).scrollTop() < 25){
            
            if ($('body').hasClass('scrolled')){

                $('body').removeClass('scrolled');

            }

        }
            
    });

    //init on load
    jQuery(window).on( "load", function() {
        
        //fire up foundation
        jQuery(document).foundation();

        //slideout menu
        var slideout = new Slideout({
            'panel': document.getElementById('panel'),
            'menu': document.getElementById('menu'),
            'padding': 256,
            'side': 'right',
            'tolerance': 70
        });

        $('.js-slideout-toggle, .slideout-menu .close-button').on('click', function(){
            slideout.toggle();
        });
            
    });

    //resize equalizer resize
    jQuery(window).on( "resize", function() {
        //fire up foundation
        if ( $('[data-equalizer]').length ) {
            Foundation.reInit('equalizer');
        }
    });

    //
    $(document).ready( function(){ 

        var cookieconsent = initCookieConsent();
        cookieconsent.run({
            current_lang : get_lang(),
            page_scripts: true,
            autorun : true, 							
            delay : 0,
            autoclear_cookies : true,	
            theme_css : globaldata.theme_url +'/assets/styles/specific-css/cookiebanner.css',
            gui_options: {
            consent_modal : {
                layout : 'cloud',               // box/cloud/bar 
                position : 'center center',     // bottom/top + left/right/center
                transition: 'slide'             // zoom/slide
            },
            settings_modal : {
                layout : 'box',                 // box/bar
                transition: 'slide',            // zoom/slide
                }
            },
            
            onAccept: function(cookies){				
            if(cookieconsent.allowedCategory('necessary')){
                var dataLayer = window.dataLayer || [];
                dataLayer.push({
                event:"CookieConsent",
                consentType:"necessary"
            });
            }
            
            
            if(cookieconsent.allowedCategory('tracking')){
                var dataLayer = window.dataLayer || [];
                dataLayer.push({
                event:"CookieConsent",
                consentType:"tracking"
            });
            }
            
            if(cookieconsent.allowedCategory('performance')){
                var dataLayer = window.dataLayer || [];
                dataLayer.push({
                event:"CookieConsent",
                consentType:"performance"
            });
            }
            
        },
    
            languages : {
                'en' : {
                    consent_modal : {
                        title :  globaldata.title,
                        description :  globaldata.consent_description,
                        primary_btn: {
                            text: globaldata.primarybtn_text,
                            role: 'accept_all'  //'accept_selected' or 'accept_all'
                        },
                        secondary_btn: {
                            text : globaldata.secondarybtn_text,
                            role : 'settings'   //'settings' or 'accept_necessary'
                        }
                    },
                    settings_modal : {
                        title : globaldata.title,
                        save_settings_btn : globaldata.pref_btn_text,
                        accept_all_btn : globaldata.primarybtn_text,
                        close_btn_label: globaldata.cookie_close_btn_text,  
                    cookie_table_headers : [
                        {col1: globaldata.cookie_table_header1 }, 
                        {col2: globaldata.cookie_table_header2 }, 


                    ],
                        blocks : [
                            {
                                title : globaldata.cookiemaintitle,
                                description: globaldata.block_description,
                            },{
                                title : globaldata.func_cookie_title,
                                description: globaldata.func_cookie_desc,
                                toggle : {
                                    value : 'necessary',
                                    enabled : true,
                                    readonly: true
                                },
                                cookie_table: [
                                {
                                    col1: 'cc_cookie',
                                    col2: globaldata.func_cookie_table2,
                                }
                                ]
                            },{
                                title : globaldata.anal_cookie_title,
                                description: globaldata.anal_cookie_desc,
                                toggle : {
                                    value : 'performance',
                                    enabled : true,
                                    readonly: false
                                },
                                cookie_table: [
                                {
                                    col1: '_ga/_ga*, _gid',
                                    col2: globaldata.anal_cookie_table_desc1,
                                },
                                                            {
                                    col1: '_gcl_au',
                                    col2: globaldata.anal_cookie_table_desc2,
                                }
                            ]
                            }/*,{
                                title : globaldata.market_cookie_title,
                                description: globaldata.market_cookie_desc,
                                toggle : {
                                    value : 'tracking',
                                    enabled : false,
                                    readonly: false
                                },
                            cookie_table: [
                                {
                                    col1: '_fbp',
                                    col2: globaldata.fb_pixel,
                                },
                            ]
                            }*/
                        ]
                    }
                }
            }
        });
        
        if(!cookieconsent.validCookie('cc_cookie')){
            var dataLayer = window.dataLayer || [];
                dataLayer.push({
                event:"CookieConsent",
                consentType:"empty"
        });

        }
    });

    /* PROJECT MASONRY PAGE */
    window.onload = function() {
        if( jQuery().isotope ) {
            $('#timeline-grid').isotope({
                percentPosition: true,
                itemSelector: '.timeline-item',
                layoutMode: 'masonry'
            });
        }
    }

})(jQuery);
